import { ProcurementsTable } from "./components";

export interface ProcurementPropsType {
  id: any; //!!!
  setSearchParams: Function;
  changeActiveTab: (arg: number) => void;
  // setIsSuccessModalOpen: (arg: boolean) => void;
  // setIsErrorModalOpen: (arg: boolean) => void;
}

const ProcurementsList = ({
  id,
  changeActiveTab,
  // setIsSuccessModalOpen,
  // setIsErrorModalOpen,
  setSearchParams,
}: ProcurementPropsType) => {
  return (
    <div className="p-10">
      {/* <ProcurementsListPageHeader /> */}
      <ProcurementsTable />
    </div>
  );
};

export default ProcurementsList;
